module.exports = __webpack_public_path__ + "static/media/03.5fbc19c3.png";